
//客户端提供的一些功能性接口，在9.7.4版本以上适用

//关闭H5页面
const closeWindow = ()=> {
  // iOS
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.closeWebview.postMessage("");

  //Android
  window.client &&
  window.client.finishActivity &&
  window.client.finishActivity(true)
}

// 客户端弹窗
const showToast = tips => {
  //iOS
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.iosToast.postMessage(tips);
};

//判断当前用户是否为VIP
const checkVipStatus= ()=> {
  // android
  if(window.androidInterface && window.androidInterface.needBuyFilter) {
    const vipStatus = window.androidInterface.needBuyFilter('5d774e80fb27048775d696db');
    //0=VIP  1=非VIP
    return vipStatus == 0
  }
}

const reportEvent= (eventObj)=> {
  const objStr = JSON.stringify(eventObj);
  //iOS
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.reportEvent.postMessage(objStr);
  //Android
  window.androidInterface &&
  window.androidInterface.reportEvent &&
  window.androidInterface.reportEvent(objStr);
}

export default {
  closeWindow,
  showToast,
  checkVipStatus,
  reportEvent
}
